import React from 'react';
import PropTypes from 'prop-types';
import FeedItem from './FeedItem';
import './Feed.scss';


const propTypes = {
    proFeeds: PropTypes.array
};

export default class Feed extends React.Component{
    constructor (props) {
        super(props);
    }

    render(){

        const {proFeeds} = this.props;

        return(
            <div className='pro-feeds-row'>
                {this.props.proFeeds.map((proFeed, index) => (
                    <FeedItem key={index} feedI={proFeed}/>
                ))}
            </div>
        )
    }
}

Feed.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/Feed/index.js